import { Box } from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import cloneDeep from "lodash/cloneDeep";
import MaterialTable, { Column } from "material-table";
import React, { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router";
import {
    AddButton,
    ConfirmationDialog,
    ConfirmationDialogState,
    PageLayout,
} from "ui/componentes";
import { LocalizationPTBr } from "util/MaterialTableUtil";
import { Collections } from "api/model/Collections";
import { useCollection } from "api/hooks/useCollection";
import { PointsByRaceConfiguration } from "api/model/PointsByRaceConfiguration";
import { useFirestore } from "react-redux-firebase";
import { useSnackbar } from "notistack";

const PointsByRaceView = () => {
    const firestore = useFirestore();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const [
        confirmationDialog,
        setConfirmationDialog,
    ] = useState<ConfirmationDialogState>({
        message: "Deseja remover está configuração?",
        showDialog: false,
    });
    const pointsByRace =
        useCollection<PointsByRaceConfiguration[]>(
            {
                collection: Collections.POINTS_BY_RACE_CONFIG,
            },
            true
        ) || [];

    const columns = useMemo<Column<PointsByRaceConfiguration>[]>(
        () => [
            {
                title: "Nome",
                field: "name",
            },
        ],
        []
    );
    const deleteConfiguration = useCallback(
        (configuration: PointsByRaceConfiguration, setConfirmationDialog) => {
            return () => {
                firestore
                    .collection(Collections.POINTS_BY_RACE_CONFIG)
                    .doc(configuration.id)
                    .delete()
                    .then(() => {
                        enqueueSnackbar("Configuração removida!", {
                            variant: "success",
                        });
                    })
                    .catch(() => {
                        enqueueSnackbar(
                            "Sem permissão para executar essa ação!",
                            { variant: "error" }
                        );
                    })
                    .finally(() => {
                        setConfirmationDialog((oldState) => ({
                            ...oldState,
                            onOk: undefined,
                            showDialog: false,
                        }));
                    });
            };
        },
        [enqueueSnackbar, firestore]
    );

    return (
        <PageLayout
            title="Configuração de pontos por corrida"
            boxCardProps={{ padding: 0 }}
        >
            <ConfirmationDialog
                showDialog={confirmationDialog.showDialog}
                message={confirmationDialog.message}
                onOk={confirmationDialog.onOk}
                onCancel={() =>
                    setConfirmationDialog((oldState) => ({
                        ...oldState,
                        onOk: undefined,
                        showDialog: false,
                    }))
                }
            />
            <MaterialTable
                components={{ Container: Box }}
                columns={columns}
                data={cloneDeep(pointsByRace)}
                actions={[
                    {
                        icon: "delete",
                        tooltip: "Remover",
                        onClick: (event, rowData) =>
                            setConfirmationDialog((oldState) => ({
                                ...oldState,
                                showDialog: true,
                                onOk: deleteConfiguration(
                                    rowData as PointsByRaceConfiguration,
                                    setConfirmationDialog
                                ),
                            })),
                    },
                    {
                        icon: "edit",
                        tooltip: "Editar",
                        onClick: (event, rowData) =>
                            history.push(
                                `/points-by-race-config/${rowData["id"]}`
                            ),
                    },
                ]}
                options={{
                    paging: false,
                    toolbar: false,
                }}
                localization={LocalizationPTBr}
            />
            <AddButton onClick={() => history.push("/points-by-race-config")}>
                <AddIcon />
            </AddButton>
        </PageLayout>
    );
};

export { PointsByRaceView };
